import {html, LitElement} from "lit-element";
import {connect} from "pwa-helpers/connect-mixin.js";
import {installRouter} from "pwa-helpers/router.js";
import {installOfflineWatcher} from "pwa-helpers/network.js";
import {updateMetadata} from "pwa-helpers/metadata.js";

import {store} from "../store";


import {toggleSidemenu, updateLocation, updateNetworkStatus, getAppSettings} from "../actions/app";
import {getProfile} from "@stofloos/actions/profile";
import {metaSelector} from "../reducers/app";


import "@stofloos/components/atoms/toasts/sw-toast-full";
import "@stofloos/components/atoms/toasts/sw-toast-simple";
import "@stofloos/components/templates/sw-template-split";
import "@stofloos/components/atoms/user/user-circle-image";
import "@stofloos/components/molecules/sidebar/sidebar-simple";
import "@stofloos/components/pages/sw-page-table";

import "./pages/page-events";
import "./pages/page-event";
import "./pages/page-order";

import {calanderIcon,
    fileText2Icon,
    statsDotsIcon,
    earthIcon,
    powerIcon,
    trophyIcon,
    usersIcon,
    wrenchIcon,
    bubblesIcon,
    userIcon,
    circleCheckIcon,
    tilesIcon} from '@stofloos/components/atoms/icons/sw-icons';
import '@stofloos/components/atoms/inputs/input-default';
import {LayoutFlex} from "@stofloos/globals/styles/layout-flex";
import {StofwareLinks} from "@stofloos/globals/styles/links";
import {StofwareText} from "@stofloos/globals/styles/typography";
import {StofwareColors} from "@stofloos/globals/styles/colors";
import {StofwareToggleElementStyle} from "@stofloos/globals/styles/toggle-element";

import { faTimes,faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import {faClock} from "@fortawesome/free-regular-svg-icons"
import { icon, library } from '@fortawesome/fontawesome-svg-core';
library.add(faTimes, faMapMarkerAlt, faClock);
import {style} from './pwa-app-style';

import {validAccessToken} from "@stofloos/actions/auth";

class PwaApp extends connect(store)(LitElement) {

    static get styles() {

        return [
            StofwareLinks,
            LayoutFlex,
            StofwareText,
            StofwareColors,
            StofwareToggleElementStyle
        ];
    }


    render() {
        if(!this._config){
            return
        }

        let header;

        header = html`
            <div class="sw-header layout horizontal">
              <div class="layout horizontal left">
                  <div class="logo-container layout vertical center-center">
                      <a href="/"><img id="logo" height="50" src="${this._config.theme.logo}"/></a>
                  </div>
              </div>
            </div> `;

        return html`
        ${this._config && this._config.theme ? html`
            ${style(this._config.theme.colors)}

            <div class="main-container layout vertical">
                
                <main class="flex layout vertical">
                   <page-events banner="${this._config.theme.banner}" ?active="${this._page === "/home"}" label="Congressen" endpoint="event" pageName="event" pageLimit="9">
                        ${header}
                   </page-events>
                   
                   <page-event banner="${this._config.theme.banner}"  ?active="${this._page === "congres"}" label="Congressen" endpoint="event" id="${this.pageId}" pageName="event">
                        ${header}
                   </page-event>
                   
                   <page-order ?active="${this._page === "bestelling"}" label="Bestelling" identifier="uuid" endpoint="enroll/status" id="${this.pageId}" pageName="bestelling">
                        ${header}
                   </page-order>
                </main>
            </div>
        
            <sw-toast-full ?active="${this._swToastOpen}">
                Je bent nu ${this._offline ? 'offline' : 'online'}.
            </sw-toast-full>
    ` : ``}
`;
    }
    static get properties() {
        return {
            appTitle: String,

            _page: String,

            pageId: String,

            _offline: Boolean,

            _swToastOpen: Boolean,

            _swToastStatus: String,

            _swToastSimple: Boolean,

            _toastSimpleMessage: String,

            _lazyResourcesLoaded: Boolean,

            _a11yLabel: Object,

            _meta: Object,

            _user: Object,

            _profile: Object,

            isAuthenticated: Boolean,

            _config: Object

        }
    }

    constructor() {
        super();
    }

    firstUpdated() {
        store.dispatch(getAppSettings()).then(() => {
            installRouter((location) => this._updateLocation(location));
            installOfflineWatcher((offline) => store.dispatch(updateNetworkStatus(offline)));
        });

        this.removeAttribute("unresolved");
    }

    _toggleSideMenu() {
        store.dispatch(toggleSidemenu({}));
    }

    updated(changedProps) {
        if (changedProps.has('_page')) {
            const pageTitle = this.appTitle + ' - ' + this._page;
            updateMetadata({
                title: pageTitle,
                description: pageTitle,
                image: this.baseURI + "images/icons/Icon-128.png"
            });
        }
    }

    stateChanged(state) {
        this.isAuthenticated = state.StofwareAuth.isAuthenticated;
        this._config = state.app.config;

        this._user = state.StofwareAuth.user;
        this._profile = state.StofwareProfile.profile;
        if(this._profile === null && this.isAuthenticated && !state.StofwareProfile.isFetching) {
            store.dispatch(getProfile);
        }

        this._page = state.app.page;
        this.pageId = state.app.pageId;
        this._meta = metaSelector(state);
        this._lazyResourcesLoaded = state.app.lazyResourcesLoaded;
        this._a11yLabel = state.app.announcerLabel;
        this._offline = state.app.offline;
        this._swToastOpen = state.app.swToastOpen;


        this._swToastSimple = state.toast.swToastOpen;
        this._swToastStatus = state.toast.status;
        this._toastSimpleMessage = state.toast.message;

    }

    _updateLocation(location) {
        store.dispatch(updateLocation(location));

        // Close the drawer - in case the *route* change came from a link in the drawer.
        this._drawerOpened = false;
    }
}

window.customElements.define('pwa-app', PwaApp);